import {
  // eslint-disable-next-line no-restricted-imports
  LocalNavigation as BeyondLocalNavigation,
  styled,
} from '@zeiss/beyond-online-react';

/**
 * Custom override of the LocalNavigation component to match our Figma designs.
 */
export const LocalNavigation: typeof BeyondLocalNavigation = styled(
  BeyondLocalNavigation,
)`
  margin-bottom: var(--spacing-responsive-m);

  @media (width >= 768px) {
    padding: 0;
    background: initial;
  }

  /* Display block on mobile to fix issue with nav item and chevron Icon not spanning full-width */
  > div {
    display: block;

    @media (width >= 768px) {
      display: flex;
    }
  }
`;
